import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { AuthService } from '../../services/AuthService';
import './PasswordRecovery.css'; // Asegúrate de importar el CSS unificado o el de login

const PasswordRecovery = () => {
  const [documentNumber, setDocumentNumber] = useState("");
  const [captchaInput, setCaptchaInput] = useState("");
  const [captchaText, setCaptchaText] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');

  useEffect(() => {
    generateCaptcha();
  }, []);

  const generateCaptcha = () => {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    let result = '';
    for (let i = 0; i < 6; i++) {
      result += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    setCaptchaText(result);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setMessageType('');

    if (!documentNumber.trim()) {
      setMessage("El número de documento es obligatorio");
      setMessageType("error");
      return;
    }

    if (!captchaInput.trim() || captchaInput.toUpperCase() !== captchaText.toUpperCase()) {
      setMessage("El código de seguridad es incorrecto");
      setMessageType("error");
      return;
    }

    setLoading(true);

    try {
      const res = await AuthService.recoverPassword(documentNumber);
      if (res.success) {
        setMessage('Se ha enviado una nueva contraseña a su correo electrónico');
        setDocumentNumber("");
        setCaptchaInput("");
        setMessageType('success');
        generateCaptcha();
      } else {
        setMessage(res.message || 'Error al procesar la solicitud');
        setMessageType('error');
      }
    } catch (error) {
      setMessage(error.response?.data?.message || 'Error de conexión. Intente nuevamente.');
      setMessageType('error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-split-container">
      {/* LADO IZQUIERDO: Branding (Igual al Login) */}
      <div className="login-image-side">
        <div className="side-top-logo">
          <img src="/logo_login.png" alt="Logo Blanco" />
        </div>
        <div className="overlay-content">
          <div className="side-text">
            <p>
              Recupera el acceso con <br />
              <span className="text-highlight">total seguridad.</span>
            </p>
          </div>
        </div>
      </div>

      {/* LADO DERECHO: Formulario de Recuperación */}
      <div className="login-form-side">
        <div className="login-box-wrapper">
          <form className="login-form" onSubmit={handleSubmit}>
            <div className="mobile-logo">
              <img src="/logo_login.png" alt="Logo" />
            </div>

            <h2 className="login-title">Recuperar Clave</h2>
            <p className="login-subtitle">Ingresa tus datos para recibir una nueva contraseña.</p>

            {message && (
              <div className={`login-error-alert ${messageType === 'success' ? 'alert-success' : ''}`}>
                {message}
              </div>
            )}

            <div className="input-group">
              <label htmlFor="documentNumber">Número de documento</label>
              <input
                type="text"
                id="documentNumber"
                value={documentNumber}
                onChange={(e) => setDocumentNumber(e.target.value)}
                placeholder="Ej: 12345678"
                disabled={loading}
              />
            </div>

            <div className="input-group">
              <label htmlFor="captcha">Código de Seguridad</label>
              <div className="captcha-container">
                <div className="captcha-display">
                  <span className="captcha-text">{captchaText}</span>
                  <button
                    type="button"
                    className="refresh-captcha"
                    onClick={generateCaptcha}
                    disabled={loading}
                    title="Generar nuevo código"
                  >
                    🔄
                  </button>
                </div>
                <input
                  type="text"
                  id="captcha"
                  name="captcha"
                  value={captchaInput}
                  onChange={(e) => setCaptchaInput(e.target.value)}
                  placeholder="Escribe el código"
                  disabled={loading}
                  maxLength={6}
                  style={{ textTransform: 'uppercase' }}
                />
              </div>
            </div>

            <button type="submit" className="login-btn" disabled={loading}>
              {loading ? 'Procesando...' : 'Enviar Solicitud'}
            </button>

            <div className="login-footer">
              <Link to="/" className="recovery-link">
                ← Volver al inicio de sesión
              </Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default PasswordRecovery;